var appFinanza = angular.module('finanzaApp', 
                ['cbl.common', 'ngRoute', 'ngAnimate', 'ui.grid', 'ui.grid.selection', 'ui.grid.pagination', 'ui.grid.exporter', 'ui.grid.resizeColumns']);

appFinanza.config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/PromotorMaskCtrl');

    $stateProvider
        .state("PromotorMaskCtrl", {
            url : "/PromotorMaskCtrl",
            controller:"PromotorMaskCtrl",
            templateUrl : "/CBL-FINANZA-WA/components/cblPromotorMask/cblPromotorMask.html",
            ncyBreadcrumb: {
                label: 'Dettaglio Provvigioni',
                parent: 'home'
            }
    })
}]);

// x TEST in locale

// appFinanza.factory('FeversSrvc', ['$http', '$window', function( $http, $window) {
//   return {
//     greet: function(text) {
//     }
//   };
// }]);

// appFinanza.factory('CblUserInfoSrvc', ['$http', '$window', function( $http, $window) {
//   const CblUserInfoSrvc = {
//     getSessionInfo: function () {
//       var sessionInfo = {};
//       sessionInfo.Canale = 'BRIO_FILIALE';

//       return {
//         sessionInfo
//       };
//     }
//   };

//   const cblUserInfoSrvc = Object.create(CblUserInfoSrvc);

//   return {
//     cblUserInfoSrvc: cblUserInfoSrvc
//   };
// }]);
